/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { NextRequest } from "next/server";

import { pathnameStartsWithLocale } from "../utils/locale.utils";

export function processCase(request: NextRequest, locales: string[]): Response | void {
	const { pathname = "/" } = request.nextUrl;

	// continue as normal if the locale path isn't yet present
	const pathStartWithLocale = locales.some((locale) => pathnameStartsWithLocale(pathname, locale));
	if (pathStartWithLocale) {
		const segments = pathname.split("/");

		// resolve the whole pathname to lowercase except the locale which may need to remain uppercase
		const newSegments = segments.map((segment, index) => {
			return index > 1 ? segment.toLowerCase() : segment;
		});
		const lowerCasedPathname = newSegments.join("/");

		if (pathname !== lowerCasedPathname) {
			request.nextUrl.pathname = lowerCasedPathname;
			return Response.redirect(request.nextUrl);
		}
	}
}
